import { createFileRoute, redirect } from "@tanstack/react-router";
import { LaunchCampaignTemplate } from "~/features/launchCampaign/LaunchCampaignTemplate";
import { resolveScFlag } from "~/lib/scFlag";
import {
  markLaunchCampaignIntroShown,
  shouldShowLaunchCampaignIntro,
} from "~/utils/launchCampaignIntro";

export const Route = createFileRoute("/_authenticated/launch-campaign")({
  beforeLoad: async () => {
    // 表示済み（sessionStorage）にも関わらずこの URL に来た場合（戻る操作・直接アクセス等）は
    // 再生せず discover へ逃がす。
    if (!shouldShowLaunchCampaignIntro()) {
      throw redirect({ to: "/discover", replace: true });
    }
    markLaunchCampaignIntroShown();

    // 今回のキャンペーン動画は Jambo 許可IPのみに表示する。対象外は discover へ逃がす。
    if (!(await resolveScFlag())) {
      throw redirect({ to: "/discover", replace: true });
    }
  },
  component: LaunchCampaignTemplate,
});
